import React from 'react';

import { TabListProps } from './TabsTypes';
import { useTabsContext } from './hooks/useTabContext';

function TabList<TValue = string>({ children }: TabListProps) {
    const { setTabList } = useTabsContext<TValue>();
    return (
        <div className="sgw-tabs__button-wrapper">
            <div className="sgw-tabs__buttons" role="tablist" ref={setTabList}>
                {children}
            </div>
        </div>
    );
}

export default TabList;
